import "./TagInput.scss"

import { Tag } from "@skylead/component-library"
import classNames from "classnames"
import _ from "lodash"
import React, { useMemo, useRef, useState } from "react"
import TextareaAutosize from "react-autosize-textarea/lib"

const TagInput = ({
  removeOnBackspace = true,
  onTagChange,
  tags = [],
  tagsFilter = "",
  placeholder,
  tagInputEmailBcc,
  isOnBlur,
  tagType,
  disabled = false,
  tagInputDisabled = false,
  isBcc = false,
  tagInputBlacklist,
  limit,
}) => {
  const textAreaRef = useRef(null)
  const tagInputClass = classNames("tag-input-wrapper input-group-wrapper input-bordered")
  const [inputValue, changeValue] = useState("")

  const isTagEmail = tagType === "email"

  const addTag = value => {
    if (isBcc && tags.length === 500) {
      return
    }
    let newTags
    if (isTagEmail) {
      newTags = [...tags, { emailOrDomain: value, blacklistType: "MANUAL" }]
    } else {
      newTags = [...tags, value]
    }
    onTagChange(newTags)
    changeValue("")
  }

  const allFilteredTags = useMemo(() => {
    let newTags = tags.map((tag, index) => ({
      id: index,
      tag,
    }))
    if (tagsFilter) {
      newTags = newTags.filter(({ tag }) =>
        (isTagEmail ? tag?.emailOrDomain : tag)
          .toLowerCase()
          .includes((tagsFilter || "").toLowerCase()),
      )
    }

    return newTags
  }, [tags, tagsFilter, isTagEmail])

  const removeTag = index => {
    const newTags = [...tags]
    newTags.splice(index, 1)
    onTagChange(newTags)
  }

  const onInputKeyDown = e => {
    const realInputValue = inputValue.trim()
    if ([13, 186].includes(e.keyCode)) {
      e.preventDefault()
      if (realInputValue === "") {
        return
      }
      addTag(realInputValue)
    } else if (removeOnBackspace && (e.keyCode === 8 || e.keyCode === 46)) {
      if (realInputValue !== "") {
        return
      }
      removeTag(tags.length - 1)
    }
  }

  const addTagOnClick = () => {
    if (isOnBlur) {
      const realInputValue = inputValue.trim()
      addTag(realInputValue)
    }
  }

  const onInputPaste = e => {
    e.preventDefault()
    const clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData
    const pastedData = clipboardData.getData("text")
    const pastedNewLineTag = pastedData.split("\n") // first split by new lines
    let allNewTags = []
    const urlPattern = /(https?:\/\/[^\s,]+)/g
    pastedNewLineTag.forEach(tag => {
      if (urlPattern.test(tag)) {
        allNewTags = [...allNewTags, ...tag.split("; ")]
      } else {
        allNewTags = [...allNewTags, ...tag.split(";")] // then split by semicolon in every line
      }
    })

    if (tagInputEmailBcc) {
      tags = _.map(tags, "email")
    }
    if (tagInputBlacklist) {
      tags = _.map(tags, "blacklist")
    }
    let newTags = []
    let allNewTrimmedTags
    if (isTagEmail) {
      const allNewEmailTags = allNewTags.map(tag => ({
        emailOrDomain: tag,
        blacklistType: "MANUAL",
      })) // add shape for new elements

      newTags = [...tags, ...allNewEmailTags].filter(tag => !!tag?.emailOrDomain.trim()) // Check which one to trim
      allNewTrimmedTags = newTags.map(tag => ({ ...tag, emailOrDomain: tag?.emailOrDomain.trim() })) // trim tags
    } else {
      newTags = [...tags, ...allNewTags].filter(tag => !!tag.trim())
      allNewTrimmedTags = newTags.map(tag => tag.trim())
    }
    onTagChange(allNewTrimmedTags)
  }

  const allTagsClassName = classNames("tag-input-wrapper-all-tags", {
    "no-tags": allFilteredTags.length === 0,
  })

  const allFilteredTagsMapper = ({ tag, id }) => (
    <Tag
      tagName={tag.email || tag.blacklist}
      isValid={tag.valid}
      id={id}
      removeTag={() => removeTag(id)}
      disabled={disabled}
    />
  )

  return (
    <div className={tagInputClass}>
      <div className="input-group">
        <div className={allTagsClassName}>{allFilteredTags.map(allFilteredTagsMapper)}</div>
        <TextareaAutosize
          ref={textAreaRef}
          className="tag-input-wrapper-input"
          onKeyDown={onInputKeyDown}
          onChange={e => {
            changeValue(e.target.value)
          }}
          onBlur={addTagOnClick}
          rows={1}
          placeholder={placeholder}
          onPaste={e => {
            if (!limit || tags.length < limit) {
              onInputPaste(e)
            }
          }}
          value={inputValue}
          disabled={disabled || tagInputDisabled}
        />
      </div>
    </div>
  )
}

// TagInput.propTypes = {
//   tagType: PropTypes.oneOf(["tag", "email"]).isRequired,
//   tagsFilter: PropTypes.string,
//   removeOnBackspace: PropTypes.bool,
//   tags: PropTypes.arrayOf(PropTypes.string),
//   disabled: PropTypes.bool,
//   tagInputDisabled: PropTypes.bool,
//   isBcc: PropTypes.bool,
//   limit: PropTypes.number,
// }

export default React.memo(TagInput)
